import { storageSessionCredentials } from '../../storage';
import { checkIsStorageCredentialsLoaded, loadRemoteFile } from '../tasks';
import { BaseRemoteFile } from './BaseRemoteFile';

export class RemoteFile extends BaseRemoteFile {
  constructor() {
    super();

    this.loadFile = async (url: string): Promise<void> => {
      await checkIsStorageCredentialsLoaded();
      const credentials = storageSessionCredentials.get();

      if (!credentials || !url) {
        this.fileData = null;
        this.onload?.();
        return;
      }

      const { blob, isError, errorType } = await loadRemoteFile(url, {
        onAbort: this.onabort || undefined,
      });

      this.fileData = blob;
      this.onload?.();

      if (isError) {
        this.errorType = errorType;
        this.fileData = null;
        this.onerror?.(`Failed to load file ${url}`);
        return;
      }
    };
  }
}
